import React from "react";
import chatbot from "./assets/naira-header-icon.png";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  AddCircleOutlineIcon,
  OpenInNewIcon,
  FullscreenIcon,
  FullscreenExitIcon,
  CloseIcon,
  Tooltip,
  InfoOutlinedIcon,
  CloseFullscreenIcon,
  ColorLensIcon
} from "app/material-framework/materialComponents";
import { useTheme } from "@mui/material/styles";
import { features } from "../app/features";

export function ChatbotHeader({
  onNewChat,
  onTogglePopout,
  onInfoClick,
  onToggleFullscreen,
  onClose,
  fullscreen,
  title = "NaiRA",
  subheader = " - Nomura AI Research Assistant",
  isPopout,
  onToggleTheme,
  isLoading,
  isHtmlReport
}) {
  const theme = useTheme();
  return (
    <AppBar
      position="static"
      sx={{ bgcolor: theme.palette.primary.main, borderRadius: isPopout ? "18px 18px 0 0" : 0 }}
      className="chatbot-header"
    >
      <Toolbar>
        <Typography
          variant="h6"
          sx={{
            color: "#FFFFFFD9",
            fontWeight: 700,
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
            flexDirection: "row"
          }}
        >
          <img src={chatbot} alt="NaiRA Chatbot" style={{ marginRight: "8px", display: "inline-block" }} />
          {title}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#FFFFFFD9",
            opacity: 0.85,
            fontSize: 13,
            fontWeight: 400,
            letterSpacing: 0.5,
            mt: 0.2,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%"
          }}
        >
          {subheader}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
          {features.chatbot.showThemeToggle && (
            <Tooltip title="Toggle theme" arrow>
              <IconButton color="inherit" onClick={onToggleTheme} aria-label="toggle theme">
                <ColorLensIcon />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Access insights effortlessly from Nomura Research content from the past 3 months" arrow>
            <IconButton color="inherit" onClick={onInfoClick} aria-label="Info">
              <InfoOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="New Chat" arrow>
            <IconButton color="inherit" onClick={onNewChat} aria-label="new chat" disabled={isLoading}>
              <AddCircleOutlineIcon />
            </IconButton>
          </Tooltip>
          {!isHtmlReport &&
            <Tooltip title={isPopout ? "Open Panel" : "Popout chatbot"} arrow>
              <IconButton
                color="inherit"
                onClick={onTogglePopout}
                aria-label={isPopout ? "Open Panel" : "Popout chatbot"}
              >
                {isPopout ? <OpenInNewIcon /> : <CloseFullscreenIcon />}
              </IconButton>
            </Tooltip>
          }
          {!isPopout && (
            <Tooltip title={fullscreen ? "Exit fullscreen" : "Open fullscreen"} arrow>
              <IconButton
                color="inherit"
                onClick={onToggleFullscreen}
                aria-label={fullscreen ? "Exit fullscreen" : "Open fullscreen"}
              >
                {fullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Close" arrow>
            <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close" alt="Close Chatbot">
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
